import { PrivacyPolicyContent } from '../types';

export const privacyPolicyContent: PrivacyPolicyContent = {
  heading: 'Privacy Policy',
  lastUpdated: 'May 19, 2025',
  disclaimer: "This Privacy Policy outlines how AZ1.AI collects, uses, and safeguards your information when you interact with our services. We are committed to transparency and the responsible handling of your data in compliance with applicable laws and industry best practices.",
  sections: [
    {
      title: 'Introduction',
      paragraphs: [
        'Welcome to AZ1. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.',
        'This privacy policy applies to all information collected through our website (https://az1.ai), as well as any related services, sales, marketing or events.'
      ]
    },
    {
      title: 'The Information We Collect',
      paragraphs: [
        'We collect several different types of information for various purposes to provide and improve our service to you:',
      ],
      bulletPoints: [
        'Personal Identification Information: Name, email address, phone number, company name',
        'Contact form submissions and correspondence',
        'Usage data and analytics information',
        'Cookies and tracking data'
      ]
    },
    {
      title: 'How We Use Your Information',
      paragraphs: [
        'We use the information we collect in various ways, including to:',
      ],
      bulletPoints: [
        'Provide, operate, and maintain our website',
        'Improve, personalize, and expand our website',
        'Understand and analyze how you use our website',
        'Develop new products, services, features, and functionality',
        'Communicate with you, including for customer service, updates, and marketing',
        'Process transactions',
        'Send you emails',
        'Find and prevent fraud'
      ]
    },
    {
      title: 'How We Share Your Information',
      paragraphs: [
        'We may share your personal information in the following situations:',
        'With Service Providers: We may share your information with service providers we use to help us provide our services.',
        'For Business Transfers: We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.',
        'With Your Consent: We may disclose your personal information for any other purpose with your consent.'
      ]
    },
    {
      title: 'Data Security',
      paragraphs: [
        'We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.',
        'We will do our best to protect your personal information. Transmission of personal information to and from our website is at your own risk.'
      ]
    },
    {
      title: 'Your Data Protection Rights',
      paragraphs: [
        'Depending on your location, you may have certain rights regarding your personal information, such as:',
      ],
      bulletPoints: [
        'The right to access, update or delete the information we have on you',
        'The right of rectification (to correct incomplete or inaccurate information)',
        'The right to object to our processing of your personal data',
        'The right of restriction (to request that we restrict the processing of your personal data)',
        'The right to data portability (to request a copy of your data in a commonly used format)',
        'The right to withdraw consent at any time'
      ]
    },
    {
      title: 'Cookies Policy',
      paragraphs: [
        'We use cookies and similar tracking technologies to track the activity on our service and hold certain information.',
        'Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our service.'
      ]
    },
    {
      title: 'Changes to This Privacy Policy',
      paragraphs: [
        'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.',
        'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.'
      ]
    },
    {
      title: 'Contact Us',
      paragraphs: [
        'If you have any questions about this Privacy Policy, you can contact us:',
        'By email: privacy@az1.ai',
        'By phone: +1 (555) 123-4567',
        'By mail: AZ1 Technologies, 123 Tech Street, San Francisco, CA 94105'
      ]
    }
  ]
};

export default {
  privacyPolicyContent
};